import { useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import { Reveal } from "./Reveal";
import { trackEvent } from "@/lib/analytics";

const JOIN_BG = "https://images.pexels.com/photos/13012915/pexels-photo-13012915.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1920";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Join = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!valid) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/subscribe`, { email });
      trackEvent("submit_signup", { category: "conversion" });
      toast.success("You've joined the Restoration. Watch your inbox.");
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="join" data-testid="join-section" className="relative py-28 md:py-40 overflow-hidden">
      <div className="absolute inset-0">
        <img src={JOIN_BG} alt="Sun rays through dark clouds" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#0A0A0A]/85" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#D4AF37] mb-6">
            The Time Is Now
          </p>
          <h2 className="font-heading font-light tracking-tight text-4xl md:text-6xl leading-tight mb-6">
            Stand with us in the <span className="italic text-[#D4AF37]">restoration</span>.
          </h2>
          <p className="text-base md:text-lg leading-relaxed font-light text-[#A39E98] mb-12">
            Join the fellowship. Receive teachings, Sabbath reminders, and the
            calendar of His Holy Feast Days — straight to your inbox.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <form
            data-testid="join-form"
            noValidate
            onSubmit={onSubmit}
            className="flex flex-col sm:flex-row max-w-xl mx-auto"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              data-testid="join-email-input"
              className="flex-1 bg-[#141311] border border-[#2B2825] text-[#F4F0EA] placeholder:text-[#A39E98]/60 px-5 py-4 focus:outline-none focus:border-[#D4AF37] transition-colors"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="join-submit-button"
              className="bg-[#D4AF37] text-[#0A0A0A] font-medium px-8 py-4 hover:bg-[#E5C865] transition-colors whitespace-nowrap disabled:opacity-60"
            >
              {loading ? "Sending..." : "Join the Fellowship"}
            </button>
          </form>
          <p className="mt-4 text-xs text-[#A39E98]/70 font-mono">
            No spam. Only truth. Unsubscribe anytime.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
